import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface CaseStudyCardProps {
  title: string;
  service: string;
  duration: string;
  challenge: string;
  solution: string;
  result: string;
  image: string;
  alt: string;
}

export default function CaseStudyCard({
  title,
  service,
  duration,
  challenge,
  solution,
  result,
  image,
  alt
}: CaseStudyCardProps) {
  return (
    <div className="bg-card rounded-lg shadow-brand overflow-hidden transition-smooth hover:shadow-brand-lg">
      <div className="h-48 overflow-hidden">
        <AppImage
          src={image}
          alt={alt}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-serif text-xl font-semibold text-foreground">{title}</h3>
          <span className="inline-block px-3 py-1 bg-accent text-primary text-xs font-medium rounded-full flex-shrink-0 ml-2">
            {service}
          </span>
        </div>
        <div className="flex items-center space-x-2 mb-4 text-sm text-muted-foreground">
          <Icon name="ClockIcon" size={16} />
          <span>Project Duration: {duration}</span>
        </div>
        <div className="space-y-4">
          <div>
            <h4 className="font-semibold text-sm text-foreground mb-2 flex items-center space-x-2">
              <Icon name="ExclamationTriangleIcon" size={16} className="text-warning" />
              <span>Challenge</span>
            </h4>
            <p className="text-sm text-muted-foreground leading-relaxed">{challenge}</p>
          </div>
          <div>
            <h4 className="font-semibold text-sm text-foreground mb-2 flex items-center space-x-2">
              <Icon name="LightBulbIcon" size={16} className="text-secondary" />
              <span>Solution</span>
            </h4>
            <p className="text-sm text-muted-foreground leading-relaxed">{solution}</p>
          </div>
          <div>
            <h4 className="font-semibold text-sm text-foreground mb-2 flex items-center space-x-2">
              <Icon name="CheckCircleIcon" size={16} className="text-success" />
              <span>Result</span>
            </h4>
            <p className="text-sm text-muted-foreground leading-relaxed">{result}</p>
          </div>
        </div>
      </div>
    </div>
  );
}